import { IBoundary } from '@domain/regulations/hooks/useRegulationBoundaryAtLocation';
import { ICoordinates } from '@app-types/geo';
import { Button } from '../Clickables/Buttons/Button';
import { Heading } from '../Heading/Heading';
import { ArrowRightIcon } from '../Icons/ArrowRightIcon';
import { LatLng } from '../LatLng/LatLng';
import { Modal } from '../Modal/Modal';
import { ModalBody } from '../Modal/ModalBody';
import { Text } from '../Text/Text';

interface ICoordinateProps {
  coordinates: ICoordinates | undefined;
  boundaryName: string | undefined;
  boundaries: IBoundary[] | undefined;
}

export const RegulationLocationContent = ({
  coordinates,
  boundaryName,
  boundaries,
}: ICoordinateProps) => {
  return (
    <>
      {boundaryName && (
        <div className="mt-2 mb-1.5">
          <Modal
            trigger={props => (
              <Button {...props} className="flex items-center gap-2" variant="textPrimary">
                {boundaryName} <ArrowRightIcon className="hidden sm:block" height={20} width={20} />
              </Button>
            )}
          >
            <ModalBody>
              <Heading variant="sm" className="mb-4">
                Regulation zones
              </Heading>
              <LatLng
                className="mb-4"
                latitude={coordinates!.latitude}
                longitude={coordinates!.longitude}
              />
              {boundaries && (
                <>
                  <Text className="text-abyss" variant="md">
                    Regulation zones based on the selected location:
                  </Text>
                  <ul>
                    {boundaries.map(boundary => (
                      <li
                        className="body-text-sm text-abyss font-semibold"
                        key={`boundary-${boundary.id}`}
                      >
                        {boundary.name}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </ModalBody>
          </Modal>
        </div>
      )}
      <LatLng latitude={coordinates!.latitude} longitude={coordinates!.longitude} />
    </>
  );
};
